import * as rootypes from "./mutations_type";
export default {
    [rootypes.RECODE_TOUCHSCREEN](state, data) {
        state.TouchScreen = data;

    },
  [rootypes.COUNTDOWNNUM](state, data) {
    state.CountTime = data;

  },

}
